import { render } from "./Logo.vue?vue&type=template&id=61705788"
const script = {}
script.render = render

export default script